import { formatInTimeZone } from 'date-fns-tz';
import { getDefaultFormats } from './DateUtils2.js';
import { islamicCalendarFormat } from './DateUtils38.js';

const localeScript = `en-${islamicCalendarFormat}`;
const getTzTimeStates = (tzDate, calendar = 'gregorian') => {
    const { timezone } = getDefaultFormats();
    const getFormat = (key) => {
        const obj = {};
        obj[key] = 'numeric';
        return new Intl.DateTimeFormat(localeScript, Object.assign(Object.assign({}, obj), { timeZone: timezone }));
    };
    if (calendar === 'hijri') {
        return {
            year: Number(getFormat('year').format(tzDate).replace(' AH', '')),
            month: Number(getFormat('month').format(tzDate)),
            day: Number(getFormat('day').format(tzDate)),
            hours: Number(getFormat('hour').format(tzDate)),
            minutes: Number(getFormat('minute').format(tzDate)),
            seconds: Number(getFormat('second').format(tzDate)),
        };
    }
    const state = {
        year: Number(formatInTimeZone(tzDate, timezone, 'yyyy')),
        month: Number(formatInTimeZone(tzDate, timezone, 'MM')),
        day: Number(formatInTimeZone(tzDate, timezone, 'dd')),
        hours: Number(formatInTimeZone(tzDate, timezone, 'HH')),
        minutes: Number(formatInTimeZone(tzDate, timezone, 'mm')),
        seconds: Number(formatInTimeZone(tzDate, timezone, 'ss')),
    };
    return state;
};

export { getTzTimeStates };
